// extracted by extract-css-chunks-webpack-plugin
module.exports = {"skeleton":"_1XUHP8","skeletonShimmer":"_3tnwYs","block":"hZf09c"};